
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import NewVoteButton from '@/components/next/NewVoteButton.vue';
import { Icon } from 'vant';
import { caseDetail } from '../api';

Vue.use(Icon);
@Component({
  components: {
    NewVoteButton,
  },
})
export default class CaseDetail extends Vue {
  voteName: string = '2022project/q2/2022economics_case_vote';
  shareTitle: string = '';
  shareSubtitle: string = '';
  item: any = {};
  async activated() {
    const res: any = await caseDetail(this.$route.query.id as string);
    this.item = res.data;
    this.shareTitle = this.item.name;
    this.shareSubtitle = this.item.recommend;
    this.onRouteChange(res.data);
  }

  onRouteChange(data: any) {
    console.log(this.shareTitle); // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: this.shareTitle,
      url: location.href,
      subtitle: '',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: this.shareTitle,
        subtitle: '',
        image: cover,
      });
    }
  }
  votSuccess(data: any, index: any) {
    this.item.votes = data;
    this.$emit('like');
  }
}
